import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import BryxTypography from "../components/BryxTypography";
/**
 * Currently expected working `withStaticMode` components
 *  - {@link BryxDatepicker}
 *  - {@link BryxDropdown}
 *  - {@link BryxPageSizeDropdown}
 *  - {@link BryxCheckbox}
 *  - {@link BryxInput}
 *  - {@link BryxTimeInput}
 *  - {@link BryxNumberInput}
 *  - {@link BryxParagraph}
 */
const withStaticMode = (WrappedComponent) => {
    return (props) => {
        const { valueFormatter, isStatic, ...rest } = props;
        const { value, label, sx, ...componentProps } = rest;
        const isValueBoolean = typeof value === "boolean";
        const shouldShowComponent = isValueBoolean && value === true;
        const staticVisibilityStyles = {
            display: isStatic ? "initial" : "none",
            visibility: isStatic ? "initial" : "hidden",
            // We need to hide the static container for checkboxes. In static mode the component will be hidden if not checked
            // Therefore, we always hide the container for boolean values
            ...(isStatic &&
                isValueBoolean && {
                display: "none",
                visibility: "hidden",
            }),
        };
        const componentVisiblityStyles = {
            display: isStatic ? (shouldShowComponent ? "initial" : "none") : "initial",
            visibility: isStatic ? (shouldShowComponent ? "visible" : "hidden") : "visible",
        };
        const formattedValue = valueFormatter && value ? valueFormatter(value) : null;
        return (_jsxs(_Fragment, { children: [_jsx("div", { style: { width: "inherit", ...componentVisiblityStyles }, children: _jsx(WrappedComponent, { ...componentProps, label: label, value: value, sx: { ...sx } }) }), _jsxs("div", { style: { width: "inherit", ...staticVisibilityStyles }, children: [label && (_jsx(BryxTypography, { variant: "body1", sx: {
                                alignSelf: "flex-start",
                                marginBottom: "8px",
                            }, children: label.toString() })), _jsx(BryxTypography, { variant: "body1", children: formattedValue ?? value?.toString() })] })] }));
    };
};
export default withStaticMode;
